import { defineMessages } from 'react-intl';

const messages = defineMessages({
    footerAbout: {
        id:'footerAbout',
        defaultMessage: 'About',
        description: 'Text for the footer about link.',
    },
    footerAccessibility: {
        id:'footerAccessibility',
        defaultMessage: 'Accessibility',
        description: 'Text for the footer accessibility link.',
    },
    footerBlog: {
        id:'footerBlog',
        defaultMessage: 'Blog',
        description: 'Text for the blog footer link.',
    },
    footerCaptionBrand: {
        id:'footerCaptionBrand',
        defaultMessage: 'Your LabXchange',
        description: 'Title for Navbar.',
    },
    footerClasses: {
        id:'footerClasses',
        defaultMessage: 'Classes',
        description: 'Text for the footer classes link.',
    },
    footerContactUs: {
        id:'footerContactUs',
        defaultMessage: 'Contact us',
        description: 'Text for the contact us link.',
    },
    footerCopyright: {
        id:'footerCopyright',
        defaultMessage: '© {year} The President and Fellows of Harvard College',
        description: 'Text for the copyright notice.',
    },
    footerDashboard: {
        id:'footerDashboard',
        defaultMessage: 'Dashboard',
        description: 'Text for dashboard footer link.',
    },
    footerDiscussion: {
        id:'footerDiscussion',
        defaultMessage: 'Discussion',
        description: 'Text for the discussion footer link.',
    },
    footerFAQ: {
        id:'footerFAQ',
        defaultMessage: 'FAQ',
        description: 'Text for the FAQ footer link.',
    },
    footerHelpCenter: {
        id:'footerHelpCenter',
        defaultMessage: 'Help Center',
        description: 'Text for the help center footer link.',
    },
    footerLibrary: {
        id:'footerLibrary',
        defaultMessage: 'Library',
        description: 'Text for the library footer link.',
    },
    footerPeople: {
        id:'footerPeople',
        defaultMessage: 'People',
        description: 'Text for the people footer link.',
    },
    footerNews: {
        id: 'footerNews',
        defaultMessage: 'News',
        description: 'Text for the news footer link'
    },
    footerPrivacyPolicy: {
        id:'footerPrivacyPolicy',
        defaultMessage: 'Privacy policy',
        description: 'Text for the privacy policy footer link.',
    },
    footerResources: {
        id:'footerResources',
        defaultMessage: 'About us',
        description: 'Text for the footer about us group.',
    },
    footerShareStory: {
        id:'footerShareStory',
        defaultMessage: 'Share your story',
        description: 'Text for the "Share your story" link.',
    },
    footerStayConnected: {
        id:'footerStayConnected',
        defaultMessage: 'Connect',
        description: 'Text for the footer connect group.',
    },
    footerStayConnectedInfo: {
        id:'footerStayConnectedInfo',
        defaultMessage: 'Sign up for our mailing list',
        description: 'Text for the footer stay connected group text.',
    },
    footerSupport: {
        id:'footerSupport',
        defaultMessage: 'Help',
        description: 'Text for the footer help group.',
    },
    footerCollaborators: {
        id:'footerCollaborators',
        defaultMessage: 'Collaborators',
        description: 'Text for the footer collaborators link',
    },
    footerTeam: {
        id:'footerTeam',
        defaultMessage: 'Co-developers',
        description: 'Text for the team footer link.',
    },
    footerTermsOfService: {
        id:'footerTermsOfService',
        defaultMessage: 'Terms of service',
        description: 'Text for the terms and conditions footer link.',
    },
    footerTutorials: {
        id:'footerTutorials',
        defaultMessage: 'Tutorials',
        description: 'Text for the tutorials footer link.',
    },
    footerGettingStarted: {
        id:'footerGettingStarted',
        defaultMessage: 'Getting started',
        description: 'Text for the getting started footer link.',
    },
    footerTeacherResources: {
        id:'footerTeacherResources',
        defaultMessage: 'Teacher resources',
        description: 'Text for the teacher resources footer link.',
    },
    footerOpenEdxLink: {
        id:'footerOpenEdxLink',
        defaultMessage: 'Built on Open edX',
        description: 'Text for open edx link',
    },
    devDemoPage: {
        id: 'devDemoPage',
        defaultMessage: 'Dev Demo Page',
        description: 'Text for dev demo page link (for development usage only)',
    },
});

export default messages;
